/**
 * @file 风险提示弹窗
 */
import { useRef } from 'react';
import { Checkbox, Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { useParams } from 'react-router-dom';
import { Modal } from '@web3/base-components';

import styles from './index.module.scss';

interface Props {
  show: boolean;
  onConfirm: (v: boolean) => void;
  onClose: () => void;
}

export const DisclaimeModal = (props: Props) => {
  const { show, onConfirm, onClose } = props;
  const fm = useFm();
  const { locale } = useParams();
  const checkedRef = useRef(false);

  const onCheckedChange = (e: Event, checked: boolean) => {
    checkedRef.current = checked;
  };

  return (
    <Modal
      open={show}
      onCancel={onClose}
      title={fm('notice')}
      size="medium"
      footer={null}
      modal={false}
    >
      <div className={styles.content}>{fm('thirdPartyWebAccess')}</div>
      <Checkbox
        className={styles.checkbox}
        onChange={onCheckedChange}
        size="small"
      >
        {fm('doNotShowMsgAgain')}
      </Checkbox>
      <Button
        variant="primary"
        className={styles.button}
        onClick={() => {
          onClose();
          onConfirm(checkedRef.current);
        }}
      >
        {fm('i_know')}
      </Button>
    </Modal>
  );
};
